import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import Clock from 'shared/icons/clock.svg'
import Money from 'shared/icons/money.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface CardProps {
  icon: string
  description: string
}

const ProsCard: FC<CardProps> = ({ icon, description }) => {
  return (
    <div className={s.card}>
      <ImageLazy
        alt=""
        src={icon}
        className={s.icon}
      />

      <p className={clsx(s.description, 'medium-14')}>{description}</p>
    </div>
  )
}

export const MInstalmentPros = () => {
  const { t } = useTranslation()

  return (
    <div className={s.pros}>
      <h4 className={clsx(s.title, 'semi-bold-20')}>
        {t('minstallment.pros_minstallment')}
      </h4>

      <div className={s.cards}>
        <ProsCard
          icon={Money}
          description={t('mplus.pay_you_comfortable')}
        />

        <ProsCard
          icon={Clock}
          description={t('mplus.available_any_time')}
        />
      </div>
    </div>
  )
}
